import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-dialog-polizza-assicurativa',
  templateUrl: './dialog-polizza-assicurativa.component.html',
  styleUrls: ['./dialog-polizza-assicurativa.component.css']
})
export class DialogPolizzaAssicurativa {

  constructor(public dialogRef: MatDialogRef<DialogPolizzaAssicurativa>) { }

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-polizza-assicurativa/dialog-polizza-assicurativa.component.ts